/**
 * File upload configuration constants
 */

// Maximum file size in bytes (10MB)
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

// Maximum file size in MB (for display purposes)
export const MAX_FILE_SIZE_MB = 10;

// Allowed file types for image uploads
export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp'
] as const;

// Helper function to validate file size
export const validateFileSize = (file: File): { isValid: boolean; error?: string } => {
  if (file.size > MAX_FILE_SIZE) {
    return {
      isValid: false,
      error: `File size exceeds ${MAX_FILE_SIZE_MB}MB limit. Please choose a smaller file.`
    };
  }
  return { isValid: true };
};

// Helper function to validate file type
export const validateFileType = (file: File): { isValid: boolean; error?: string } => {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type as any)) {
    return {
      isValid: false,
      error: 'Invalid file type. Please upload a JPG, PNG, GIF, or WebP image.'
    };
  }
  return { isValid: true };
};

// Combined validation function
export const validateFile = (file: File): { isValid: boolean; error?: string } => {
  const sizeValidation = validateFileSize(file);
  if (!sizeValidation.isValid) {
    return sizeValidation;
  }

  const typeValidation = validateFileType(file);
  if (!typeValidation.isValid) {
    return typeValidation;
  }

  return { isValid: true };
};
